import { render, staticRenderFns } from "./Lineups.vue?vue&type=template&id=3f1cbac2&scoped=true&"
import script from "./Lineups.vue?vue&type=script&lang=js&"
export * from "./Lineups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1cbac2",
  null
  
)

export default component.exports